export type AdvisorGroupJSON = {
  id: number;
  title: string;
  name: string;
  name_abbreviated: string;
  key: string;
  disable_consumer_access_to_forms: boolean;
};

export class AdvisorGroup {
  constructor(
    public id: number,
    public title: string,
    public formsDisabled: boolean,
    public name?: string,
    public nameAbbreviated?: string,
    public key?: string
  ) {}

  static fromJSON = (json: AdvisorGroupJSON): AdvisorGroup => {
    return new AdvisorGroup(
      json.id,
      json.title,
      json.disable_consumer_access_to_forms,
      json.name,
      json.name_abbreviated,
      json.key
    );
  };

  toJSON = (): any => {
    return {
      id: this.id,
      title: this.title,
      name: this.name,
      name_abbreviated: this.nameAbbreviated,
      key: this.key,
      disable_consumer_access_to_forms: this.formsDisabled,
    };
  };
}
